<div class="mt-3 col-12" style="display: flex;justify-content: flex-start;" *ngIf="!carregando">
  <div class="col-2 md:col-6 lg:col-3" *ngIf="!carregando" style="padding: 0px 0px 0px 0px;">
    <p-dropdown [options]="dealers" [showClear]="true" optionLabel="descricao" [(ngModel)]="selectedDealer"
      placeholder="{{'Dealers'}}"></p-dropdown>
  </div>
  <div class="col-2 md:col-6 lg:col-3 ml-2" *ngIf="!carregando" style="padding: 0px 0px 0px 0px;">
    <p-dropdown [options]="servicos" [showClear]="true" optionLabel="descricao" [(ngModel)]="selectedProcesso"
      placeholder="{{'Processos'}}"></p-dropdown>
  </div>
  <div class="col-2 md:col-6 lg:col-3 ml-2" *ngIf="!carregando" style="padding: 0px 0px 0px 0px;">
    <p-dropdown [options]="status" [showClear]="true" optionLabel="descricao" [(ngModel)]="selectedStatus"
      placeholder="{{'Status'}}"></p-dropdown>
  </div>
  <div class="col-2 md:col-6 lg:col-3 ml-3 ml-2" *ngIf="!carregando" style="padding: 0px;">
    <div style="display: flex;">
      <button class="btn btn-primary mb-2 buttonPadrao btnBuscar" (click)="buscar()">
        Buscar
        <em class="fa fa-search fa-xs"></em>
      </button>
    </div>
  </div>
  <div class="md:col-6 lg:col-3 ml-1" *ngIf="!carregando"
    style="padding: 0px;flex: 2 0 29.666667%;max-width: 38.666667%;">
    <button class="btn btn-outline-secondary mb-2 float-right" (click)="exportarExcel()">
      <em class="fa fa-download fa-xs"></em>
      Export Excel
    </button>
  </div>
</div>
<app-loading [exibir]="carregando"></app-loading>
<div class="content mt-3 col-12" *ngIf="!carregando">
  <div *ngIf="servicoDados?.length <= 0" class="sem-registros text-muted mt-2">
    Nenhum registro para exibir...
  </div>
  <p-table #dt dataKey="idStatusServico" *ngIf="servicoDados?.length > 0" [value]="servicoDados"
    selectionMode="multiple" [(selection)]="selectedDados"
    styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
    [columns]="cols" [autoLayout]="true" id="excel-table" [rows]="50"
    [customSort]="true" (sortFunction)="customSort($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [translate]="getTranslate(col.header)" class="text-center percentual" [pSortableColumn]="col.field"
          *ngFor="let col of columns" style="background-color:black;color:white;">
          {{col.header}}
          <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dados let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns">
          <ng-container *ngIf="col.field === 'precisaAtualizar'">
            <td class="text-center">
              <p-checkbox class="checkGrid" [(ngModel)]="dados[col.field]" binary="true" disabled="true"></p-checkbox>
            </td>
          </ng-container>
          <ng-container *ngIf="col.field !== 'precisaAtualizar'">
            <td class="text-center" [ngStyle]="{backgroundColor:getColor(dados[col.field])}">
              <div [translate]="getTranslate(dados)">
                {{dados[col.field]}}
                <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dados[col.field])">
                </ng-container>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator *ngIf="totalRegistros > 50" [rows]="tamanhoPagina" [(first)]="first" [totalRecords]="totalRegistros"
    [rowsPerPageOptions]="[10,30,50,100,200]" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registros">
  </p-paginator>

</div>